import BarLineAreaChart from './BarLineAreaChart'

export default BarLineAreaChart
